import { render, staticRenderFns } from "./extract-network.vue?vue&type=template&id=5bdbf0c0"
import script from "./extract-network.vue?vue&type=script&lang=js"
export * from "./extract-network.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports